import React, { useRef } from "react";
import { goToNext, goPrevious, useFormValue, useFieldAutoFocus } from '../common';
import { FormLabel } from "./FormLabel";
import styled from "styled-components";
import { TextArea } from "semantic-ui-react";
import { useFluidForm, useFormInstance } from "../FormContext";
import "../common-form-styles.css";
import { isObject, formatInferredValue, FIELD_TYPES, } from '../../../../shared';
import { useFormInstanceDispatch, } from '../FormInstance.service';
import { GenericStructuredOutput } from "./GenericStructuredOutput";
import ValidationIcon from './ValidationIcon';
export const InputRegion = styled.input.withConfig({
    shouldForwardProp: (prop) => !['isFocused', 'width', 'validationType'].includes(prop),
}).attrs(props => ({
    className: `${regionClassName(props)}`
})) `
  width: ${props => props.width ? `${props.width}px` : '100%'};
  transition: all 0.15s ease;
`;
export const TextAreaRegion = styled(TextArea).withConfig({
    shouldForwardProp: (prop) => !['isFocused', 'width', 'validationType'].includes(prop),
}).attrs(props => ({
    className: `fluid-textarea ${regionClassName(props)}`
})) `
  /* CSS classes handle most styling */
`;
function regionClassName({ isFocused, validationType }) {
    const classNames = ['fluid-input'];
    if (isFocused)
        classNames.push('fluid-input-focus');
    switch (validationType) {
        case 'correct':
            classNames.push('fluid-input-valid');
            break;
        case 'confirm':
        case 'missing-part':
            classNames.push('fluid-input-warning');
            break;
        case 'retry':
            classNames.push('fluid-input-invalid');
    }
    return classNames.join(' ');
}
export function FieldTextComponent({ fieldPath, width, options, validationType, ...props }) {
    const fluidForm = useFluidForm();
    const field = fluidForm.getFieldRenderView(fieldPath);
    const config = fluidForm.getFieldConfigByFieldPath(fieldPath);
    let ref = useRef(null);
    let readOnly = config?.readOnly || false;
    let omitLabel = options?.omitLabel || false;
    const instanceId = useFormInstance();
    const dispatch = useFormInstanceDispatch(instanceId);
    let [value, setValue] = useFormValue(field.fieldPath);
    useFieldAutoFocus(ref, field.fieldPath, options?.autoFocus);
    const handleKeyDown = (event) => {
        let fieldName = event.target.getAttribute("data-fieldName");
        if (event.key === "Tab") {
            event.preventDefault();
            goToNext(fieldName, fluidForm);
            return;
        }
        if (event.key === "Backspace" && event.target.value === "") {
            event.preventDefault();
            goPrevious(fieldName, fluidForm);
            return;
        }
    };
    const handleValueChange = (value) => {
        setValue(value);
    };
    const handleBlur = () => {
        fluidForm.unfocusField(field.fieldPath);
    };
    if (isObject(value) && options?.useStructuredOutput && typeof FIELD_TYPES[config.type].parts !== 'string') {
        return React.createElement(GenericStructuredOutput, { fieldPath: fieldPath, width: width, options: options, value: value, setValue: setValue, validationType: validationType });
    }
    if (isObject(value)) {
        value = formatInferredValue(value, config);
    }
    return React.createElement(React.Fragment, null,
        !omitLabel && React.createElement(FormLabel, { fieldPath: fieldPath, config: config, options: options }),
        config.longText && (React.createElement("div", { className: "flex" },
            React.createElement(TextAreaRegion, { "data-fieldname": field.fieldPath, isFocused: fluidForm.isFocused(field.fieldPath), suppressContentEditableWarning: true, onFocus: (event) => {
                    fluidForm.setCurrentField(field.fieldPath);
                }, onBlur: handleBlur, onKeyDown: handleKeyDown, onChange: (event) => {
                    handleValueChange(event.target.value);
                }, value: (value || ""), readOnly: readOnly, validationType: validationType }),
            validationType && React.createElement(ValidationIcon, { validationType: validationType }))),
        !config.longText && (React.createElement("div", { className: "flex" },
            React.createElement(InputRegion, { ref: ref, name: field.fieldPath, id: `ff-${field.fieldPath}`, type: "text", "data-fieldname": field.fieldPath, isFocused: fluidForm.isFocused(field.fieldPath), suppressContentEditableWarning: true, onFocus: (event) => {
                    fluidForm.setCurrentField(field.fieldPath);
                }, onBlur: handleBlur, width: width, onKeyDown: handleKeyDown, onChange: (event) => {
                    handleValueChange(event.target.value);
                }, value: (value || ""), readOnly: readOnly, validationType: validationType }),
            validationType && React.createElement(ValidationIcon, { validationType: validationType }))));
}
